<ng-container *ngIf="theme$ | async as theme">
  <div [ngClass]="theme">
    <mat-toolbar color="transparent" class="justify-space-between toolbar-container-full toolbar-container">
      <sit-icon-button class="d-none d-md-flex section-container h-100 justify-center" style="width: 64px;"
        [btnType]="'menu-latera'" (click)="toggleSideMenu()" [icon]="Icon.menu_ng" [colorClass]="'text-color-white'"
        [sizeClass]="'icon-size-32'" [alt]="
          properties.logoText === 'FUNCIONARIO'
            ? 'Encuentre información georreferenciada sobre tráfico, incidentes y accidentes, agentes, niveles de CO2, aforo, en la ciudad de Almería.'
            : 'Encuentre información georreferenciada sobre tráfico, niveles de CO2 y aforo de la ciudad de Almería.'
        ">
      </sit-icon-button>

      <ng-container *ngIf="properties.logoText === 'FUNCIONARIO'">

        <ng-container *ngIf="properties?.logo as logo">
          <section class="h-100 section-container d-flex d-md-none">
            <picture class="logo-container">
              <img *ngIf="properties?.sublogo  as sublogo" [src]="sublogo" alt="'Logo Almeria ciudad'"
                class="h-100 width-300-px">
              <img [src]="logo" alt="'Logo Almeria ciudad'" class="w-auto h-100">
            </picture>
          </section>
        </ng-container>

        <ng-container>
          <div class="h-100 container-indicators">
            <section class="h-100 section-container indicators-box">
              <div class="full-width d-flex justify-center">
                <citizen-indicators [indicators]="indicators"></citizen-indicators>
              </div>
            </section>
          </div>
        </ng-container>

        <ng-container *ngIf="properties?.menus as menus">
          <section class="h-100 section-container d-flex d-md-none px-24-px">
            <nav class="d-flex align-items-center justify-space-between container-tools ">
              <ng-container *ngFor="let menu of menus; let i = index">
                <div class="trigger-button" *ngIf="menu.component; else cardsMenu">
                  <div *ngIf="menu.alt === 'Notificaciones' && notificationsAmount > 0"
                    class="notification-badge-counter">
                    {{notificationsAmountFormatted}}
                  </div>
                  <sit-icon-button *ngIf="menu.statefulComponent; else statelessComponent"
                    (click)="toggleStatefulMenu(menu.alt, true)" [icon]="menu.icon" mat-icon-button
                    [matMenuTriggerFor]="floatingMenu" matTooltip="{{menu.alt}}" class="hover-animation">
                  </sit-icon-button>
                  <ng-template #statelessComponent>
                    <sit-icon-button [icon]="menu.icon" mat-icon-button [matMenuTriggerFor]="floatingMenu"
                      matTooltip="{{menu.alt}}" class="hover-animation"></sit-icon-button>
                  </ng-template>
                  <mat-menu #floatingMenu="matMenu" xPosition="after" (closed)="toggleStatefulMenu(menu.alt, false)">
                    <ng-container *ngIf="statefulComponentsState[menu.alt]">
                      <ng-container *ngComponentOutlet="menu.component"></ng-container>
                    </ng-container>
                  </mat-menu>
                </div>
                <ng-template #cardsMenu>
                  <sit-menu [properties]="menu" class="d-flex align-items-center"></sit-menu>
                </ng-template>
              </ng-container>
            </nav>
          </section>
        </ng-container>
      </ng-container>

    </mat-toolbar>
  </div>
</ng-container>